import React from 'react';

export const HeatSupplyLogo = ({ width = '18', height = '18', fill = 'var(--icon-color-base)' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 16.5C12.3137 16.5 15 13.8137 15 10.5C15 6 9 1.5 9 1.5C8.70877 3.36519 8.42363 4.36618 7.5 6C6.59931 5.58367 6.375 5.25 6 4.3125C4.5 6 3 8.25 3 10.5C3 13.8137 5.68629 16.5 9 16.5Z"
        stroke={fill}
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path d="M7.5 12.75L10.5 9.75" stroke={fill} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M7.5 9.75H7.50675M10.4933 12.75H10.5"
        stroke={fill}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
